import axios from 'axios'
import { getToken, clearSession } from '../utils/auth'

const basePath = (process.env.VUE_APP_BASE_URL || '/').replace(/\/$/, '') || ''

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api',
  timeout: 15000
})

request.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

request.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      clearSession()
      const loginUrl = `${basePath}/#/login`
      if (window.location.hash !== '#/login') {
        window.location.href = loginUrl
      }
    }
    return Promise.reject(error)
  }
)

export default request
